import { render, staticRenderFns } from "./CardPregunta.vue?vue&type=template&id=ce1e55b8&"
import script from "./CardPregunta.vue?vue&type=script&lang=js&"
export * from "./CardPregunta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports